import { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import styles from "./FacultyProfile.module.css";
import { ImageUrlPrefix } from "../../../../labels";
import { customStyles } from "../../../../pages/customStyles";
import { AxiosInstance } from "../../../../axios";
import MonthDatePicker from "../../MonthDatePicker";

export const TechFaculty = (props) => {
  const [classOption, setClassOption] = useState([]);
  const [thqOption, setThqOption] = useState([]);
  const [thqOptionCoa, setThqOptionCoa] = useState([]);
  const [Kcom, setKcom] = useState([]);

  useEffect(() => {
    AxiosInstance.get("api/codevalues?codetype=CLASS_THQ").then((res) => {
      const classOptions = res.data.map((item) => ({
        value: item.name,
        label: item.name,
      }));
      setClassOption(classOptions);
    });

    AxiosInstance.get("api/codevalues?codetype=THQ_K").then((res) => {
      const kcom = res.data.map((item) => ({
        value: item.name,
        label: item.name,
      }));
      setKcom(kcom);
    });

    AxiosInstance.get("api/codevalues?codetype=THQ_COA").then((res) => {
      const thqCoaOptions = res.data.map((item) => ({
        value: item.name,
        label: item.name,
      }));
      setThqOptionCoa(thqCoaOptions);
    });
  }, []);

  return (
    <fieldset className="mt-3" key={props.record.id}>
      <legend className="w-auto">
        Technical Qualification {props.index > 1 ? `- ${props.index}` : ""}
      </legend>
      <form className="row g-3">
        {/* Technical Course */}
        <div className="col-md-6">
          <label className="form-label confirm_value">Technical Course</label>
          <Select
            className="shadow-none input-font-size margin-left-zero"
            id={`FacultyName`}
            name={`name`}
            isDisabled={props.admission_status === 1}
            value={
              props.record.name
                ? { value: props.record.name, label: props.record.name }
                : null
            }
            onChange={(option) =>
              props.TechhandleChanges(option, props.index, "name")
            }
            options={props.technicalOption
              .filter((item) => item && item.label)
              .sort((a, b) => a.label.localeCompare(b.label))}
            isSearchable
            placeholder="Select an option"
            maxMenuHeight={200}
            filterOption={(option, searchText) =>
              option.label.toLowerCase().includes(searchText.toLowerCase())
            }
            styles={customStyles}
          />
          {props.record.error_name && (
            <small className="error_message">{props.record.error_name}</small>
          )}
        </div>

        {/* Level */}
<div className="col-md-6">
  <label className="form-label confirm_value">
    {props.record.name === "Steno"
      ? "Stenographer Level"
      : props.record.name === "COA"
      ? "Computer Office Automation"
      : props.record.name === "Knowledge in computer" ||
        props.record.name === "Others"
      ? "Course In Computer"
      : "Typewriting Level"}
  </label>

  {props.record.name !== "Nil" && (
    <>
      {props.record.name === "COA" && (
        <Select
          isSearchable
          className="shadow-none input-font-size margin-left-zero"
          placeholder="Please select"
          id="level"
          name="level"
          isDisabled={props.admission_status === 1}
          styles={customStyles}
          options={thqOptionCoa}
          value={
            props.record.level
              ? { value: props.record.level, label: props.record.level }
              : null
          }
          onChange={(e) => {
            e.__fieldName = "level";
            props.TechhandleChange(e, props.index);
          }}
        />
      )}

      {props.record.name === "Knowledge in computer" && (
        <Select
          isSearchable
          className="shadow-none input-font-size margin-left-zero"
          id="level"
          name="level"
          isDisabled={props.admission_status === 1}
          styles={customStyles}
          options={thqOption}
          value={
            props.record.level
              ? { value: props.record.level, label: props.record.level }
              : null
          }
          onChange={(e) => {
            e.__fieldName = "level";
            props.TechhandleChange(e, props.index);
          }}
        />
      )}

      {props.record.name !== "COA" &&
        props.record.name !== "Knowledge in computer" && (
          <Select
            isSearchable
            className="shadow-none input-font-size margin-left-zero"
            id="level"
            name="level"
            isDisabled={props.admission_status === 1}
            styles={customStyles}
            value={
              props.record.level
                ? { value: props.record.level, label: props.record.level }
                : null
            }
            onChange={(e) => {
              e.__fieldName = "level";
              props.TechhandleChange(e, props.index);
            }}
            options={[
              { value: "Junior", label: "Junior" },
              { value: "Senior", label: "Senior" },
              { value: "HighSpeed", label: "High Speed" },
            ]}
          />
        )}

      {props.record.error_level && (
        <small className="error_message">{props.record.error_level}</small>
      )}
    </>
  )}
</div>


        {/* Language */}
        {props.record.name !== "Nil" && (
          <>
<div className="col-md-6">
  <label htmlFor={`lang`} className="form-label confirm_value">
    Language
  </label>
  <Select
    className="shadow-none input-font-size margin-left-zero"
    id={`lang`}
    name={`lang`}
    disabled={props.admission_status === 1}
    value={
      props.record.lang
        ? { value: props.record.lang, label: props.record.lang }
        : null
    }
    onChange={(e) => {
      e.__fieldName = "lang";
      props.TechhandleChange(e, props.index);
    }}
    required
    options={[
      { value: "English", label: "English" },
      { value: "Tamil", label: "Tamil" },
      { value: "Hindi", label: "Hindi" },
    ]}
  />
</div>

            {props.record.error_edu_medium && (
              <small className="error_message">
                {props.record.error_edu_medium}
              </small>
            )}

            <div className="col-md-6">
              <label htmlFor={`Cnum`} className="form-label confirm_value">
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                disabled={props.admission_status === 1 ? true : false}
                name="Cnum"
                onChange={(e) => props.TechhandleChange(e, props.index)}
                placeholder="Certificate Number"
                value={props.record.Cnum}
                autocomplete="Certificate Number"
                required
              />
            </div>
            {props.record.error_certificate_no && (
              <small className="error_message">
                {props.record.error_certificate_no}
              </small>
            )}
          </>
        )}

        {props.record.name !== "Nil" && (
          <>
            {/* Grade */}
<div className="col-md-6">
  <label htmlFor={`grade`} className="form-label confirm_value">
    Grade
  </label>
  <Select
    className="shadow-none input-font-size"
    id={`grade`}
    name={`grade`}
    disabled={props.admission_status === 1}
    value={
      props.record.grade
        ? { value: props.record.grade, label: props.record.grade }
        : null
    }
    onChange={(e) => {
      e.__fieldName = "grade";
      props.TechhandleChange(e, props.index);
    }}
    required
    isSearchable
    options={classOption}
    styles={customStyles}
  />
  {props.record.error_grade && (
    <small className="error_message">{props.record.error_grade}</small>
  )}
</div>


            {/* Year of Passing */}
            <div className="col-md-6">
              <label htmlFor={`year`} className="form-label confirm_value">
                Year of Passing
              </label>
              <MonthDatePicker
                disabledProperty={props.admission_status === 1}
                name={"year"}
                txtAdSpass={props.txtadTech}
                handleIdChange={(date) =>
                  props.TechhandleChange_date(date, props.index, "year")
                }
                fieldsId={props.record.id}
                fieldInput={props.record.year}
              />
              {props.record.error_year_of_passing && (
                <small className="error_message">
                  {props.record.error_year_of_passing}
                </small>
              )}
            </div>

            {/* IMAGE */}
            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {props.record.file && (
                    <a
                      href={`${ImageUrlPrefix}/${props.record.file}`}
                      target="_blank"
                      download
                    >
                      <span className="material-icons download_icon align-middle text-danger">
                        file_download
                      </span>
                    </a>
                  )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      id={`file`}
                      type="file"
                      disabled={props.admission_status === 1 ? true : false}
                      name={`file`}
                      onChange={(e) => props.TechhandleChange(e, props.index)}
                      className="InputsSelectFile m-0"
                      placeholder="Upload Certificate"
                      autocomplete="file"
                      required
                    />
                  </div>
                  {props.record.original_file_path && (
                    <div className="mt-1">
                      <span className="">
                        {props.record.original_file_path || ""}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <div className="col-md-12 d-flex justify-content-end g-3">
          {/* Show remove button only if there's more than one technical qualification */}
          {props.length > 1 && (
            <a
              className={`${styles?.AddMore} me-3`}
              onClick={() =>
                props.DeleteQual(props.index, props.record.name)
              }
              style={{ cursor: "pointer" }}
            >
              <span
                className="material-icons align-middle me-1"
                style={{ fontSize: "20px" }}
              >
                remove_circle
              </span>
              Delete Technical Qualification
            </a>
          )}

          {/* Show Add More button only for the last fieldset */}
          {props.index === props.length - 1 && (
            <a
              className={styles.AddMore}
              onClick={props.admission_status === 1 ? "" : props.handleAdd}
              style={{ cursor: "pointer" }}
            >
              <span
                className="material-icons align-middle me-1"
                style={{ fontSize: "20px" }}
              >
                add_circle
              </span>
              Add More Technical Qualification
            </a>
          )}
        </div>
      </form>
    </fieldset>
  );
};
